<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-autocomplete
                  :items="countyList"
                  item-text="Name"
                  item-value="ID"
                  label="所在縣市"
                  v-model="form.CountyID"
                  :rules="formRules.county"
                ></v-autocomplete>
                <v-text-field
                  list="datalist-client-in__client-addedit-dialog"
                  v-model="form.Name"
                  label="客戶名稱"
                  :rules="formRules.name"
                >
                  <template v-slot:append>
                    <datalist id="datalist-client-in__client-addedit-dialog">
                      <option
                        v-for="client in activeClientListOfCounty"
                        :key="`client-datalist-${client.ID}`"
                      >{{client.Name}}</option>
                    </datalist>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="save"
        >儲存</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    editingId: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    form: {},
    defaultForm: {
      Name: ""
    }
  }),
  computed: {
    formRules() {
      return {
        name: [v => !!v || "請輸入名稱"],
        county: [v => !!v || "請選擇縣市"]
      };
    },
    formTitle() {
      return this.editingId === -1 ? "新增" : "編輯";
    },
    countyList() {
      if (this.form.CountyID > 0) {
        let idx = this.activeCountyList.findIndex(
          o => o.ID === this.form.CountyID
        );
        if (idx < 0) {
          var inactiveCounty = this.$store.state.county.list.find(
            o => o.ID === this.form.CountyID
          );
          if (inactiveCounty) {
            return [inactiveCounty].concat(this.activeCountyList);
          }
        }
      }
      return this.activeCountyList;
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    editingIdx() {
      return this.$store.state.client.list.findIndex(
        o => o.ID == this.editingId
      );
    },
    activeClientListOfCounty () {
      return this.activeClientList.filter(o => !this.form.CountyID || o.CountyID == this.form.CountyID)
    },
    ...mapGetters([
      "activeClientList",
      "activeCountyList",
      "clients",
      "countries"
    ])
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    save() {
      if (!this.$refs.form.validate()) return;

      for (let client of this.activeClientList) {
        if (client.Name != this.form.Name) continue;
        let county = this.countries.find(o => o.ID == client.CountyID);
        if (county.ID != this.form.CountyID) continue;
        if (
          !window.confirm(
            `已經有一位同樣名稱/同樣縣市的客戶「${county.Name}${this.form.Name}」\n確定仍要新增?`
          )
        ) {
          return;
        }
        break;
      }

      this.isLoading = true;
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          this.isLoading = false;
          return alert("發生異常：無法找到編輯物件");
        }
        this.$services.client
          .edit(this, this.form)
          .then(res => {
            this.$set(
              this.$store.state.client.list,
              this.editingIdx,
              res.data.result
            );
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$services.client
          .add(this, this.form)
          .then(res => {
            this.$store.state.client.list.splice(0, 0, res.data.result);
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resetForm() {
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          alert("發生異常：無法找到編輯物件");
          return this.close();
        }
        this.form = JSON.parse(
          JSON.stringify(this.$store.state.client.list[this.editingIdx])
        );
      } else {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
    this.isLoading = true;
    this.$services.county.prepareData(this).finally(() => {
      this.isLoading = false;
    });
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>